const verbMap = {
  read: 'Read',
  write: 'Write',
  manage: 'Manage',
  admin: 'Administer',
  create: 'Create',
  update: 'Update',
  delete: 'Delete',
  list: 'List',
  search: 'Search',
  sync: 'Sync',
  openid: 'OpenID',
  profile: 'Profile',
  email: 'Email',
  offline_access: 'Offline Access',
};

const nounMap = {
  crm: 'CRM',
  contacts: 'Contacts',
  contact: 'Contact',
  users: 'Users',
  user: 'User',
  leads: 'Leads',
  lead: 'Lead',
  deals: 'Deals',
  deal: 'Deal',
  pipeline: 'Pipeline',
  pipelines: 'Pipelines',
  calendar: 'Calendar',
  calendars: 'Calendars',
  events: 'Events',
  event: 'Event',
  mail: 'Mail',
  messages: 'Messages',
  message: 'Message',
  tickets: 'Tickets',
  ticket: 'Ticket',
  ads: 'Ads',
  campaigns: 'Campaigns',
  campaign: 'Campaign',
};

const titleCase = (value) =>
  value
    .split(' ')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');

const mapToken = (token) => {
  const normalized = token.toLowerCase();
  if (verbMap[normalized]) {
    return verbMap[normalized];
  }

  if (nounMap[normalized]) {
    return nounMap[normalized];
  }

  return titleCase(normalized.replace(/[_-]/g, ' '));
};

export const prettifyScope = (scope) => {
  if (!scope || typeof scope !== 'string') {
    return '';
  }

  const normalized = scope.trim();
  if (!normalized) {
    return '';
  }

  const parts = normalized
    .replace(/\//g, '.')
    .replace(/:/g, '.')
    .split('.')
    .filter(Boolean);

  if (!parts.length) {
    return normalized;
  }

  const mapped = parts.map(mapToken);
  const maybeVerb = mapped[mapped.length - 1];

  if (verbMap[parts[parts.length - 1]?.toLowerCase()]) {
    const entity = mapped.slice(0, -1).join(' ');
    return entity ? `${maybeVerb} ${entity}` : maybeVerb;
  }

  return mapped.join(' ');
};
